import { makeAutoObservable, runInAction, toJS } from "mobx";
import { carbonInventoryService } from "../services";
import { showToast } from "@/lib/utils/toast";

const toPositiveInt = (value, fallback) => {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 1) return fallback;
  return parsed;
};

class CarbonBankSubmissionsStore {
  page = 1;
  pageSize = 5;
  total = 0;
  totalPages = 0;

  carbonSubmissionsDetails = null;
  carbonSubmissionsData = [];
  carbonOverviewData = null;
  filterOptions = { year: "all", status: "all" };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: false });
  }

  setPage = (page) => {
    this.page = toPositiveInt(page, 1);
  };

  setPageSize = (size) => {
    this.pageSize = toPositiveInt(size, 10);
    this.page = 1;
  };

  setFilter = (key, value) => {
    this.filterOptions[key] = value;
  };

  loadCarbonBankSubmissions = async () => {
    try {
      const data = await carbonInventoryService.getCarbonBankSubmission(
        this.filterOptions.year,
        this.filterOptions.status,
      );
      runInAction(() => {
        this.carbonSubmissionsData = data?.submissions;
        this.total = data?.submissions.length || [];
      });
    } catch (error) {
      showToast.error(error?.message || "Failed to load!");
    }
  };

  loadCarbonBankOverview = async () => {
    try {
      const data = await carbonInventoryService.getCarbonBankOverview(
        this.filterOptions.year,
        this.filterOptions.status,
      );
      runInAction(() => {
        this.carbonOverviewData = data;
      });
    } catch (error) {
      showToast.error(error?.message || "Failed to load!");
    }
  };

  loadCarbonBankSubmissionsDetails = async (id) => {
    try {
      const data =
        await carbonInventoryService.getCarbonBankSubmissionsDetails(id);
      runInAction(() => {
        this.carbonSubmissionsDetails = data;
      });
    } catch (error) {
      showToast.error(error?.message || "Failed to load!");
    }
  };

  reviewCarbonSubmissionsReview = async (body) => {
    try {
      const data =
        await carbonInventoryService.reviewCarbonBankSubmissionsReview(body);
      runInAction(() => {
        showToast.success("Successfully saved!");
      });
    } catch (error) {
      showToast.error(error?.message || "Failed to load!");
    }
  };
}
export const carbonBankSubmissionsStore = new CarbonBankSubmissionsStore();
